import { pickBy } from 'es-toolkit';
import qs from 'qs';
import { getLocalStorageItem } from './browserStorage';

const jsonHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

export const checkAllowValue = (value: unknown) => {
  if (typeof value === 'undefined') {
    return false;
  }
  if (Array.isArray(value) && value.length === 0) {
    return false;
  }
  return true;
};

const httpRequest = async (
  method: string | undefined,
  url: RequestInfo,
  params: Record<string, unknown> | undefined,
  headers: HeadersInit | undefined,
  settings = { contentType: 'json', withTokenRequest: false }
) => {
  const isBrowser = typeof window !== 'undefined';
  const storedUser = isBrowser ? getLocalStorageItem('current-user') : '';

  const options: RequestInit = {
    method,
    credentials: 'omit',
    headers: {
      ...(settings.contentType === 'json' ? { ...jsonHeaders } : {}),
      ...headers,
      ...(isBrowser &&
      settings.withTokenRequest &&
      storedUser &&
      JSON.parse(storedUser).token
        ? {
            Authorization: `Bearer ${JSON.parse(storedUser).token}`,
          }
        : {}),
    },
  };
  if (params && settings.contentType === 'json') {
    options.body = JSON.stringify(params);
  }
  if (params && settings.contentType === 'formData') {
    const formData = new FormData();
    Object.entries(params).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((item) => {
          formData.append(key, item);
        });
      } else {
        formData.append(key, value as string | Blob);
      }
    });
    options.body = formData;
  }
  const rawResponse = await fetch(url, options);
  const bodyText = (await rawResponse.text()) || JSON.stringify(null);
  const data = JSON.parse(bodyText);
  const { status } = rawResponse;
  return { status, data };
};

export const http = {
  post: async (
    url: RequestInfo,
    params?: Record<string, unknown> | undefined,
    headers?: HeadersInit | undefined,
    settings = { contentType: 'json', withTokenRequest: false }
  ) => httpRequest('POST', url, params, headers, settings),
  patch: async (
    url: RequestInfo,
    params?: Record<string, unknown> | undefined,
    headers?: HeadersInit | undefined,
    settings = { contentType: 'json', withTokenRequest: false }
  ) => httpRequest('PATCH', url, params, headers, settings),
  delete: async (
    url: RequestInfo,
    params?: Record<string, unknown> | undefined,
    headers?: HeadersInit | undefined,
    settings = { contentType: 'json', withTokenRequest: false }
  ) => httpRequest('DELETE', url, params, headers, settings),
  get: async <R = any>(
    url: string | URL,
    params?: Record<string, unknown> | null,
    headers?: HeadersInit | null,
    option?: {
      arrayFormat?: 'repeat' | 'indices' | 'brackets' | 'comma';
      contentType?: string;
      withTokenRequest?: boolean;
    }
  ) => {
    const urlWithQuery = new URL(url);
    const values = pickBy(params || {}, checkAllowValue);
    urlWithQuery.search = qs.stringify(values, {
      arrayFormat: option?.arrayFormat ? option.arrayFormat : 'repeat',
    });
    const response = await httpRequest(
      'GET',
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      urlWithQuery,
      null,
      headers,
      option
    );
    const isError = !response.status || response.status >= 400;
    if (isError) {
      // eslint-disable-next-line @typescript-eslint/no-throw-literal
      throw {
        statusCode: response.status || null,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        data: response.data || response.message,
      };
    }
    return response.data as R;
  },
};
